import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth.jsx';
import { ArrowRight, X, Sparkles } from './Icons.jsx';

const SESSION_KEY = 'mm-guest-banner-dismissed';
const ONBOARDED_KEY = 'mm-onboarded-v1';

// Soft, non-blocking nudge for guests who have been through onboarding but
// haven't signed up. Dismissible per session — never gates content.
export default function GuestSignupBanner() {
  const { user, loading } = useAuth();
  const loc = useLocation();
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem(SESSION_KEY) === '1'; } catch { return false; }
  });

  let onboarded = false;
  try { onboarded = Boolean(localStorage.getItem(ONBOARDED_KEY)); } catch {}

  const hiddenRoute =
    loc.pathname.startsWith('/drill') ||
    loc.pathname.startsWith('/tutor-portal') ||
    loc.pathname === '/signup' ||
    loc.pathname === '/login' ||
    loc.pathname === '/verify-email';

  if (loading || user || dismissed || !onboarded || hiddenRoute) return null;

  const dismiss = () => {
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch {}
    setDismissed(true);
  };

  return (
    <div style={bar}>
      <div style={inner}>
        <Sparkles width="15" height="15" style={{ flexShrink: 0, color: '#e9d5ff' }} />
        <span style={{ fontSize: 13, fontWeight: 600, color: '#fff', flex: 1, minWidth: 0 }}>
          You're browsing as a guest — your drill scores and study plan aren't being saved.
        </span>
        <Link to="/signup" style={cta}>
          Create free account <ArrowRight width="13" height="13" />
        </Link>
        <button onClick={dismiss} aria-label="Dismiss" style={closeBtn}><X width="14" height="14" /></button>
      </div>
    </div>
  );
}

const bar = {
  background: 'linear-gradient(135deg, #5b21b6, #7c3aed)',
  borderBottom: '1px solid rgba(255,255,255,0.12)',
  position: 'relative', zIndex: 5,
};
const inner = {
  maxWidth: 1300, margin: '0 auto',
  display: 'flex', alignItems: 'center', gap: 12,
  padding: '8px 16px',
};
const cta = {
  background: '#fff', color: '#5b21b6',
  padding: '5px 12px', borderRadius: 6, fontSize: 12.5, fontWeight: 700,
  textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 4,
  flexShrink: 0, whiteSpace: 'nowrap',
};
const closeBtn = {
  background: 'transparent', border: 'none', cursor: 'pointer',
  color: 'rgba(255,255,255,0.7)', padding: 4, display: 'grid', placeItems: 'center',
  flexShrink: 0,
};
